<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <EditActiveStatusDefaultForm />
    </PageRowWrapper>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import EditActiveStatusDefaultForm from '@/components/settings/stock-registers/activestatusdefault/EditActiveStatusDefaultForm'
import LoadingPage from '@/components/spinner/LoadingPage'

export default {
  name: 'EditActiveStatusDefaultEdit',
  components: {
    PageTitle,
    PageRowWrapper,
    EditActiveStatusDefaultForm,
    LoadingPage
  },

  computed: {
    ...mapState({
      editEquipment: state => state.editequipment.editEquipmentById
    })
  },

  methods: {
    ...mapActions('editequipment', ['fetchById'])
  }
}
</script>